import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { OrdersStatus } from "../../../../Constants/Constants";
import { OrderStatusChart } from "../../../../Data/General/Widgets/Chart";

const OrderStatusWidgets = () => {
  return (
    <Col xl="7" lg="12" className="box-col-7">
      <Card>
        <CommonCardHeader title={OrdersStatus} />
        <CardBody>
          <div className="chart-container">
            <ReactApexChart id="linechart" options={OrderStatusChart} series={OrderStatusChart.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderStatusWidgets;
